export const it = {
  conversations: {
    pageTitle: 'Training Conversations',
    title: 'Conversazioni disponibili',
    description: 'Scopri le conversazioni disponibili per il tuo training.',
    example: {
      title: 'Risultati Assessment Soft Skills',
      description:
        'Analizza i risultati dettagliati del tuo assessment sulle soft skills e identifica le aree di miglioramento.',
      buttonLabel: 'Avvia conversazione',
    },
    chooseAvatar: {
      title: 'Scegli il tuo Agent AI',
      subtitle: 'Scegli e sentiti a casa',
      cta: {
        continue: 'Continua',
      },
    },
    testControls: {
      title: 'Inizia la video-conversazione',
      instructions:
        'Assicurati che il microfono e la fotocamera funzionino correttamente prima di iniziare. Puoi fare un test veloce con i tasti che trovi qui a destra. Una volta che sei pronto, clicca su "Inizia la conversazione".',
      cta: {
        start: 'Inizia la conversazione',
      },
    },
  },
};
